import { gql } from '@apollo/client';

export const CREATE_PROTECTED_DOWNLOAD = gql`
  mutation CreateProtectedDownload(
    $documentId: ID!
    $purpose: ProtectedDownloadPurpose!
    $asReviewer: Boolean
    $piiNoticeAcknowledged: Boolean
    $piiNoticeVersion: String
  ) {
    createProtectedDownload(
      documentId: $documentId
      purpose: $purpose
      asReviewer: $asReviewer
      piiNoticeAcknowledged: $piiNoticeAcknowledged
      piiNoticeVersion: $piiNoticeVersion
    ) {
      __typename
      downloadId
      url
      fileName
      expiresAt
      purpose
    }
  }
`;
